module.exports = __webpack_public_path__ + "static/img/m1_t1_edge.c1089e50.jpg";